import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {CommonResponse} from '../interfaces/home';

@Injectable({
  providedIn: 'root',
})
export class ProcessRequiringApprovalService {
  constructor(private http: HttpClient) { }
  baseUrl = environment.baseUrl+'ProcessesRequiringApproval/';
  // fetch all ApprovalLimit in the database
  allProcessRequiringApprovalData(): Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl);
  }
  getProcessRequiringApproval(id: any):Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl +id);
  }
  getProcessRequiringApprovalByName(name: any):Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl + 'name/' + name);
  }
  postProcessRequiringApproval(data: any){
    return this.http.post(this.baseUrl, data);
  }
  deleteProcessRequiringApproval(id: any){
    return this.http.delete(this.baseUrl +id);
  }
  updateProcessRequiringApproval(id: any, data: any){
    return this.http.put(this.baseUrl +id, data);
  }
}
